<template>
  <div>
    <div class="search-table">
      <DataGrid
        :data="searchResult"
        :border="false"
        :striped="true"
        :style="{height:bottom_height+'px'}"
        selection-mode="single"
        class="f-full"
        @rowDblClick="rowDblClick"
        @rowContextMenu="grid_right_click"
      >
        <GridColumn
          :sortable="true"
          field="name"
          align="left"
          title="名称"
          width="150"
        >
          <template
            slot="body"
            slot-scope="scope"
          >
            <span :title="scope.row.name">{{ scope.row.name }}</span>
          </template>
        </GridColumn>
        <GridColumn
          :sortable="true"
          field="fullName"
          align="left"
          title="路径"
        >
          <template
            slot="body"
            slot-scope="scope"
          >
            <span :title="scope.row.fullName">{{ scope.row.fullName }}</span>
          </template>

        </GridColumn>
        <GridColumn
          :sortable="true"
          field="type"
          title="类型"
          align="left"
          width="150"
        >
          <template
            slot="body"
            slot-scope="scope"
          >
            <div
              v-if="scope.row.type==='folder'"
              title="文件夹"
              class="title"
            >
              文件夹
            </div>
            <div
              v-if="scope.row.type==='project'"
              title="项目"
              class="title"
            >
              项目
            </div>
            <div
              v-if="scope.row.type==='server'"
              title="服务器"
              class="title"
            >
              服务器
            </div>
            <div
              v-if="scope.row.type==='logicalGroup'"
              title="逻辑组"
              class="title"
            >
              逻辑组
            </div>
            <div
              v-if="scope.row.type==='deviceGroup'"
              title="设备组"
              class="title"
            >
              设备组
            </div>
            <div
              v-if="scope.row.type==='device'"
              title="设备"
              class="title"
            >
              设备
            </div>
            <div
              v-if="scope.row.type==='subDevice'"
              title="子设备"
              class="title"
            >
              子设备
            </div>
            <div
              v-if="scope.row.type==='onlineChart'"
              title="曲线图-实时"
              class="title"
            >
              曲线图-实时
            </div>
            <div
              v-if="scope.row.type==='stateChange'"
              title="状态变化"
              class="title"
            >
              状态变化
            </div>
            <div
              v-if="scope.row.type==='timeChart'"
              title="时间表-本地"
              class="title"
            >
              时间表-本地
            </div>
            <div
              v-if="scope.row.type==='user'"
              title="用户"
              class="title"
            >
              用户
            </div>
            <div
              v-if="scope.row.type==='group'"
              title="用户组"
              class="title"
            >
              用户组
            </div>
            <div
              v-if="scope.row.type==='userGroupAlarm'"
              title="用户组-报警"
              class="title"
            >
              用户组-报警
            </div>
            <div
              v-if="scope.row.type==='alarmControl'"
              title="报警控制"
              class="title"
            >
              报警控制
            </div>
            <div
              v-if="scope.row.type==='value_Analog'"
              title="值-模拟量"
              class="title"
            >
              值-模拟量
            </div>
            <div
              v-if="scope.row.type==='value_Multistate'"
              title="值-多态"
              class="title"
            >
              值-多态
            </div>
            <div
              v-if="scope.row.type==='value_Binary'"
              title="值-二进制"
              class="title"
            >
              值-二进制
            </div>
            <div
              v-if="scope.row.type==='value_String'"
              title="值-字符串"
              class="title"
            >
              值-字符串
            </div>
            <div
              v-if="scope.row.type==='BinaryInput'"
              title="数字了输入"
              class="title"
            >
              数字量输入
            </div>
            <div
              v-if="scope.row.type==='BinaryOutput'"
              title="数字了输出"
              class="title"
            >
              数字量输出
            </div>
            <div
              v-if="scope.row.type==='AnalogInput'"
              title="模拟量输入"
              class="title"
            >
              模拟量输入
            </div>
            <div
              v-if="scope.row.type==='AnalogOutput'"
              title="模拟量输出"
              class="title"
            >
              模拟量输出
            </div>
            <div
              v-if="scope.row.type==='timeEvent'"
              title="时间事件-对象"
              class="title"
            >
              时间事件-对象
            </div>
            <div
              v-if="scope.row.type==='timeEventList'"
              title="时间事件-列表"
              class="title"
            >
              时间事件-列表
            </div>
            <div
              v-if="scope.row.type==='objectTransfer'"
              title="对象传输"
              class="title"
            >
              对象传输
            </div>
          </template>
        </GridColumn>
      </DataGrid>
    </div>
    <Menu
      ref="grid_context_menu"
      :duration="1000"
      @itemClick="tree_menuItemClick"
    >
      <MenuItem
        text="打开"
        iconCls="icon-open"
      >
      <div
        align="right"
        style="font-size: 12px"
      >Ctrl+O</div>
          </MenuItem>
      <MenuItem
        text="新窗口中打开"
        iconCls="icon-new-open"
      >
      <div
        align="right"
        style="font-size: 12px"
      >Ctrl+Shift+O</div>
          </MenuItem>
      <MenuItem
        text="搜索"
        iconCls="icon-search"
      >
      <div
        align="right"
        style="font-size: 12px"
      >Ctrl+F</div>
          </MenuItem>
      <Menu-sep />

      <Menu-sep v-if="!'subDevice'===selectedNodeType" />
      <MenuItem
        text="刷新"
        iconCls="icon-reflash"
      >
      <div
        align="right"
        style="font-size: 12px"
      >F5</div>
          </MenuItem>
      <Menu-sep />
      <MenuItem
        text="事件视窗"
        iconCls="icon-event-window"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        text="授权"
        iconCls="icon-auth"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        text="剪切"
        iconCls="icon-cut"
      ></MenuItem>
      <MenuItem
        text="复制"
        iconCls="icon-copy"
      ></MenuItem>
      <MenuItem
        text="粘贴"
        iconCls="icon-paste"
      ></MenuItem>
      <MenuItem
        text="趋势记录"
        iconCls="icon-onlineChart"
      ></MenuItem>
      <MenuItem
        text="实时曲线"
        iconCls="icon-onlineChartLog"
      ></MenuItem>
      <Menu-sep />
      <MenuItem
        v-if="!('BinaryInput,BinaryOutput,value_Binary,AnalogInput,AnalogOutput,value_Analog,value_Multistate,value_String').includes(selectedNodeType) || pointType"
        text="重命名"
        iconCls="icon-rename"
      ></MenuItem>
      <MenuItem
        v-if="!('BinaryInput,BinaryOutput,value_Binary,AnalogInput,AnalogOutput,value_Analog,value_Multistate,value_String').includes(selectedNodeType) || pointType"
        text="删除"
        iconCls="icon-delete"
      ></MenuItem>
      <Menu-sep
        v-if="!('BinaryInput,BinaryOutput,value_Binary,AnalogInput,AnalogOutput,value_Analog,value_Multistate,value_String').includes(selectedNodeType) || pointType"
      />
      <MenuItem
        text="属性"
        iconCls="icon-property"
      ></MenuItem>
    </Menu>
  </div>
</template>
<script>
import timeExchange from '../../utils/timestampToFormat.js'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data () {
    return {
      visible: false,
      selectedNode: null,
      selectedNodeType: '',
      pointType: false,
      params: {
        pageSize: 50,
        pageNum: 1
      },
      total: 0,
      pages: 0,
      loading: false,
      timestamp: 0,
      timeExchange: timeExchange,
      bottom_height: `${(document.documentElement.clientHeight - 100) * 0.5 - 45}`
    }
  },
  computed: {
    ...mapState({
      objectInfo: 'objectInfo',
      searchResult: 'searchResult'
    })
  },
  mounted () {

  },
  destroyed () {

  },
  methods: {
    ...mapMutations({
      userShow: 'USER_SHOW',
      groupShow: 'GROUP_SHOW',
      pointShow: 'POINT_SHOW',
      stateChangeShow: 'CHANGE_OF_STATE_SHOW',
      alarmControlShow: 'ALARM_CONTROL_SHOW',
      alarmChartDialogShow: 'ALARMCHART_PROPERTIES_DIALOG_SHOW',
      userGroupAlarmShow: 'GROUP_ALARM_SHOW',
      timeChartShow: 'TIME_CHART_SHOW', // 时间表
      holidayChartShow: 'HOLIDAY_CHART_SHOW', // 假期计划表
      propertiesDialogShow: 'PROPERTIES_DIALOG_SHOW',
      authorityShow: 'AUTHORITY_SHOW',
      onlineChartDialogShow: 'ONLINECHART_PROPERTIES_DIALOG_SHOW',
      objectTransferShow: 'OBJECT_TRANSFER_SHOW',
      timeEventObejctShow: 'TIME_EVENT_OBJECT_SHOW',
      timeEventListShow: 'TIME_EVENT_LIST_SHOW'
    }),
    ...mapActions({
      showPointValueDialog: 'showPointValueDialog'
    }),
    rowDblClick (row) {
      this.$store.state.nodeTree = row
      this.$store.state.objectInfo = row
      // this.$store.state.searchSelect = row
      if (row.type === 'onlineChart') {
        this.$store.state.leftClickNode = new Date().getTime()
        this.$router.push({name: 'onlineChart', query: {id: row.id,t:Date.now()}})
      }
      if (row.type === 'trendLog') {
        this.$store.state.leftClickNode = new Date().getTime()
        this.$router.push({name: 'graphiCallyShow', query: {id: row.id}})
      }
      else if (('root,project,folder,server,logicalGroup,deviceGroup,device,subDevice').includes(row.type)) {
        this.$store.state.leftClickNode = new Date().getTime()
        this.$router.push({name: 'List', query: {id: row.id}})
      } else {
        switch (row.type) {
          case 'BinaryInput':
          case 'BinaryOutput':
          case 'value_Binary':
            this.showPointValueDialog({
              type: 'Binary',
              isEdit: true
            })
            break
          case 'AnalogInput':
          case 'AnalogOutput':
          case 'value_Analog':
            this.showPointValueDialog({
              type: 'Analog',
              isEdit: true
            })
            break
          case 'value_Multistate' :
            this.showPointValueDialog({
              type: 'Multistate',
              isEdit: true
            })
            break
          case 'value_String' :
            this.showPointValueDialog({
              type: 'String',
              isEdit: true
            })
            break
          case 'user':
            this.userShow()
            break
          case 'userGroup':
            this.groupShow()
            break
          case 'stateChange':
            this.stateChangeShow()
            break
          case 'alarmControl':
            this.alarmControlShow()
            break
          case 'alarmReceiverEmail':
            this.alarmChartDialogShow()
            break
          case 'userGroupAlarm':
            this.userGroupAlarmShow()
            break
          case 'timeChart':
            this.timeChartShow()
            break
          case 'timeEvent':
            this.timeEventObejctShow()
            break
          case 'timeEventList':
            this.timeEventListShow()
            break
          case 'objectTransfer':
            this.objectTransferShow()
            break
          default:
            break
        }
      }
    },
    grid_right_click (event) {
      this.$refs.grid_context_menu.showContextMenu(event.originalEvent.x, event.originalEvent.y)
      this.$store.state.objectInfo = event.row
      this.selectedNode = event.row
      this.selectedNodeType = event.row.type
      if (this.selectedNode.attribute && this.selectedNode.attribute.pointType) {
        this.pointType = this.selectedNode.attribute.pointType
      } else {
        this.pointType = false
      }
    },
    tree_menuItemClick (event) {
      switch (event) {
        case '属性':
          switch (this.objectInfo.type) {
            case 'BinaryInput':
            case 'BinaryOutput':
            case 'value_Binary':
              this.showPointValueDialog({
                type: 'Binary',
                isEdit: true
              })
              break
            case 'AnalogInput':
            case 'AnalogOutput':
            case 'value_Analog':
              this.showPointValueDialog({
                type: 'Analog',
                isEdit: true
              })
              break
            case 'value_Multistate' :
              this.showPointValueDialog({
                type: 'Multistate',
                isEdit: true
              })
              break
            case 'value_String' :
              this.showPointValueDialog({
                type: 'String',
                isEdit: true
              })
              break
            case 'user':
              this.userShow()
              break
            case 'userGroup':
              this.groupShow()
              break
            case 'stateChange':
              this.stateChangeShow()
              break
            case 'alarmControl':
              this.alarmControlShow()
              break
            case 'alarmReceiverEmail':
              this.alarmChartDialogShow()
              break
            case 'userGroupAlarm':
              this.userGroupAlarmShow()
              break
            case 'timeChart':
              this.timeChartShow()
              break
            case 'project':
              this.propertiesDialogShow()
              break
            case 'server':
              this.propertiesDialogShow()
              break
            case 'folder':
              this.propertiesDialogShow()
              break
            case 'logicalGroup':
              this.propertiesDialogShow()
              break
            case 'deviceGroup':
              this.propertiesDialogShow()
              break
            case 'onlineChart':
              this.onlineChartDialogShow()
              break
            case 'timeEvent':
              this.timeEventObejctShow()
              break
            case 'timeEventList':
              this.timeEventListShow()
              break
            case 'objectTransfer':
              this.objectTransferShow()
              break

            default:
              break
          }
          break
        case '重命名':
          switch (this.objectInfo.type) {
            case 'BinaryInput':
            case 'BinaryOutput':
            case 'value_Binary':
              this.showPointValueDialog({
                type: 'Binary',
                isEdit: true
              })
              break
            case 'AnalogInput':
            case 'AnalogOutput':
            case 'value_Analog':
              this.showPointValueDialog({
                type: 'Analog',
                isEdit: true
              })
              break
            case 'value_Multistate' :
              this.showPointValueDialog({
                type: 'Multistate',
                isEdit: true
              })
              break
            case 'value_String' :
              this.showPointValueDialog({
                type: 'String',
                isEdit: true
              })
              break
            case 'user':
              this.userShow()
              break
            case 'userGroup':
              this.groupShow()
              break
            case 'stateChange':
              this.stateChangeShow()
              break
            case 'alarmControl':
              this.alarmControlShow()
              break
            case 'alarmReceiverEmail':
              this.alarmChartDialogShow()
              break
            case 'userGroupAlarm':
              this.userGroupAlarmShow()
              break
            case 'timeChart':
              this.timeChartShow()
              break
            case 'project':
              this.propertiesDialogShow()
              break
            case 'server':
              this.propertiesDialogShow()
              break
            case 'folder':
              this.propertiesDialogShow()
              break
            case 'logicalGroup':
              this.propertiesDialogShow()
              break
            case 'deviceGroup':
              this.propertiesDialogShow()
              break
            case 'onlineChart':
              this.onlineChartDialogShow()
              break
            case 'timeEvent':
              this.timeEventObejctShow()
              break
            case 'timeEventList':
              this.timeEventListShow()
              break
            case 'objectTransfer':
              this.objectTransferShow()
              break
            default:
              break
          }
          break
        case '授权':
          this.authorityShow()
          break
        case '删除':
          this.visible = true
          break
        default:
          break
      }
    }
  }
}
</script>
<style lang='scss'>
.search-table {
  margin-bottom: 12px
}
.pagination-box {
  min-width: 620px;
  .gs-pagination {
    margin-bottom: 16px;
  }
}
// #rMenu {
//   position:absolute;
//   visibility:hidden;
//   top:0;
//   background-color: #fff;
//   text-align: left;
//   padding: 2px;
//   border: 1px solid #DFDFDF;
//   font-size: 14px;
// }
// .right-menu-li{

// 	margin: 1px 0;
// 	padding: 5px 15px 5px 10px;
// 	cursor: pointer;
// 	list-style: none outside none;
// 	background-color: #fff;
//   border-bottom: 1px solid #DFDFDF;
// }
</style>



// WEBPACK FOOTER //
// src/components/alarm/searchList.vue